module.exports = __webpack_public_path__ + "04_long_brown.5a8fe55a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer5/04_long_brown.png
// module id = qrPq
// module chunks = 0